var React = require('react');

function DragInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"r":"9.5","transform":"matrix(1 0 0 -1 22 11)","stroke":"#ED9C78","key":0}),React.createElement("line",{"y1":"-0.5","x2":"8.4853","y2":"-0.5","transform":"matrix(-0.707107 -0.707107 -0.707107 0.707107 6 17)","stroke":"#ED9C78","key":1}),React.createElement("line",{"y1":"-0.5","x2":"8.4853","y2":"-0.5","transform":"matrix(0.707107 -0.707107 -0.707107 -0.707107 0 11)","stroke":"#ED9C78","key":2}),React.createElement("line",{"x1":"37.6464","y1":"16.6464","x2":"43.6465","y2":"10.6464","stroke":"#ED9C78","key":3}),React.createElement("line",{"x1":"43.6464","y1":"11.3536","x2":"37.6464","y2":"5.35354","stroke":"#ED9C78","key":4})]);
}

DragInline.defaultProps = {"viewBox":"0 0 44 22","fill":"none"};

module.exports = DragInline;

DragInline.default = DragInline;
